var map = {
	"./bosch_cleaningrobot.jpg": 422,
	"./bosch_icon.png": 382,
	"./lionsbot_icon.png": 61,
	"./lionsbot_r3.png": 459,
	"./samsung_icon.png": 893
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 860;